import styled from "styled-components";
import {ClockLastLoginDefaultBox} from "./clock-last-login.default.box";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";

const PcBox = styled(ClockLastLoginDefaultBox)`
  ::before {
    background-position: -493px -506px;
  }
`;

const MobileBox = styled(ClockLastLoginDefaultBox)`
  ::before {
    width: 1rem;
    height: 1rem;
    margin: 0;
    background-size: 850px;
    background-position: -285px -293px;
  }
`;

export const ClockLastLoginCasino777Box = styledByDevice(PcBox, MobileBox);
